import api from './api.config';
import app from './app.config';
import cms from './cms.config';
import links from './links.config';

export default {
  api,
  app,
  cms,
  links,
};
